import axios from "axios"
import BASEURL from "../pages/Utils/Baseurl"

export const  apicall= async (query,variables={})=>{
   try{
    const res = await axios.post(BASEURL,{
        query,
        variables
    })
    return ({success:true,data:res.data})
   }
   catch(err){
    console.log(err,"errmsg");
    
   return { success: false, error: err };
   }
}